import { IMonthCalendarEvent } from '@/components/month-calendar/types/IMonthCalendarEvent';
import { QP_CALENDAR_VIEW_MODE } from '@/constants/queryParams';
import { useSearchParams } from '@/hooks/useSearchParams';
import { useListCalendarEvents } from '@/queries/calendar-event.queries';
import { useHistory } from 'react-router-dom';
import { Temporal } from 'temporal-polyfill';

export function useMonthViewController() {
	const params = useSearchParams();
	const calendarIds = params.get('ids');
	const history = useHistory();

	if (!calendarIds) {
		throw Error('Missing calendar IDs');
	}

	const today = Temporal.Now.zonedDateTimeISO();

	const calendarEventsQuery = useListCalendarEvents({
		calendarIds: calendarIds,
		includeEventsWithoutInterval: true,
		timeMin: today
			.with({ day: 1, hour: 0, minute: 0, second: 0, millisecond: 0, microsecond: 0 })
			.toInstant()
			.toString(),
		timeMax: today
			.with({ month: today.month + 1, hour: 0, minute: 0, second: 0, millisecond: 0, microsecond: 0 })
			.toInstant()
			.toString(),
	});

	function handlePlannerClick() {
		params.set(QP_CALENDAR_VIEW_MODE, 'planner');
		history.push({ search: params.toString() });
	}

	const events: IMonthCalendarEvent[] =
		calendarEventsQuery.data?.items
			.filter((e) => {
				if (!e.interval) {
					return false;
				}
				return true;
			})
			.map((c) => {
				return {
					id: c.id,
					start: Temporal.ZonedDateTime.from(
						`${c.interval!.inclusiveStart.dateTime}[${c.interval!.inclusiveStart.timeZone}]`
					),
					end: Temporal.ZonedDateTime.from(
						`${c.interval!.exclusiveEnd.dateTime}[${c.interval!.exclusiveEnd.timeZone}]`
					),
					title: c.summary,
				};
			}) ?? [];

	return {
		events,
		calendarEventsQuery,
		handlePlannerClick,
	};
}
